<div [ngClass]="{'rounded form-group mt-3 p-3 border': true, 'border-danger': items.length === 0}">
  <div class="col col-12 p-0">

    <ng-container *ngIf="allowCollapse">
      <button
        type="button"
        class="btn btn-outline-light me-1"
        (click)="collapse.toggle()"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseExample">
        <i [ngClass]="{'fa': true, 'fa-caret-down': !isCollapsed, 'fa-caret-up': isCollapsed}"></i>
      </button>
    </ng-container>

    <div class="btn-group" role="group">
      <button
        type="button"
        [ngClass]="{'btn': true, 'active': condition === getAndCondition()}"
        (click)="setCondition(getAndCondition())">AND</button>
      <button
        type="button"
        [ngClass]="{'btn': true, 'active': condition === getOrCondition()}"
        (click)="setCondition(getOrCondition())">OR</button>
    </div>

    <button
      type="button"
      class="btn btn-outline-danger float-lg-end"
      [disabled]="disableRemove"
      (click)="onRemoveGroup(index)">
      <i class="fa fa-minus"></i></button>

    <button
      type="button"
      class="btn btn-outline-success float-lg-end ms-1 me-1"
      [disabled]="deepLevel < level"
      (click)="addGroup()">
      <i class="fa fa-plus"></i> Group</button>

    <button
      type="button"
      class="btn btn-outline-secondary float-lg-end"
      (click)="addRule()">
      <i class="fa fa-plus"></i> Rule</button>

  </div>

  <div class="group-container" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <ng-container *ngFor="let item of items; let i = index">
      <ng-container *ngIf="item.type === 'RULE'">
        <app-rule
          [level]="level + 1"
          [index]="i"
          [ruleInput]="getRuleFromInput(i)"
          (ruleChangeEvent)="onRuleValueChanged($event)"
          (removeRuleEvent)="onRemoveChildItem($event)"></app-rule>
      </ng-container>
      <ng-container *ngIf="item.type === 'GROUP'">
        <app-group-of-rules
          [level]="level + 1"
          [index]="i"
          [groupRuleInput]="getGroupRuleFromInput(i)"
          (groupChangeEvent)="onGroupValueChanged($event)"
          (removeGroupEvent)="onRemoveChildItem(i)"></app-group-of-rules>
      </ng-container>
    </ng-container>
  </div>
</div>
